module.exports = "pegasus/assets/blocks/header-6-tech.png";